import { UrlObject } from 'node:url';

import React from 'react';

import { Link } from '@/i18n/routing';

type ProgramMobileListItemLayoutProps = {
    href?: string | ({ pathname: string } & Omit<UrlObject, 'pathname'>);
    imageComponent: React.JSX.Element;
    titleComponent: React.JSX.Element;
    showingsSlider?: React.JSX.Element;
    title: string;
};

export function ProgramMobileListItemLayout(props: ProgramMobileListItemLayoutProps): React.JSX.Element {
    return (
        <div
            className="flex flex-col py-16 space-y-16"
            role="group"
            aria-label={props.title}>
            <div className="relative flex flex-col space-y-12">
                {props.href && (
                    <Link
                        className="absolute top-0 left-0 h-full w-full cursor-pointer"
                        href={props.href}
                        aria-label={props.title}
                        /*
                         * Prefetch the full page data beyond the loading.js boundaries by setting the prefetch prop to true
                         * (See: https://nextjs.org/docs/app/building-your-application/routing/linking-and-navigating#2-prefetching)
                         */
                        prefetch={false}
                    />
                )}

                {/* Title and Details */}
                <div className="select-none pointer-events-none">{props.titleComponent}</div>

                {/* Trailer & Poster */}
                <div className="select-none pointer-events-none">{props.imageComponent}</div>
            </div>

            {props.showingsSlider ? props.showingsSlider : null}
        </div>
    );
}
